import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Newsletter() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            toast.error("Please enter a valid email address.");
            return;
        }
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setEmail("");
            toast.success("You're on the list. Expect a letter from us soon.");
        }, 700);
    };

    return (
        <section className="relative py-24 lg:py-32 bg-navy overflow-hidden" data-testid="newsletter-section">
            <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
                <div className="absolute -top-20 -left-20 w-[40rem] h-[40rem] rounded-full bg-gold blur-[160px]" />
                <div className="absolute -bottom-40 -right-20 w-[30rem] h-[30rem] rounded-full bg-gold blur-[140px]" />
            </div>
            <div className="relative max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                <div className="grid lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-7">
                        <p className="overline">The Itinerary · Monthly Letter</p>
                        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium mt-4 leading-tight max-w-2xl">
                            Slow journeys, rare rates and one <em className="italic text-gold">quiet destination</em> each month.
                        </h2>
                    </div>

                    <motion.form
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        onSubmit={submit}
                        className="lg:col-span-5"
                        data-testid="newsletter-form"
                    >
                        <div className="flex items-end gap-4 border-b border-white/20 focus-within:border-gold transition-colors pb-2">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="your@email.com"
                                required
                                data-testid="newsletter-email-input"
                                className="flex-1 bg-transparent outline-none text-white placeholder-white/35 py-2 font-sans"
                            />
                            <button
                                type="submit"
                                disabled={loading}
                                data-testid="newsletter-submit"
                                className="flex items-center gap-2 text-gold hover:text-[#E5C158] text-xs uppercase tracking-widest font-medium transition-colors disabled:opacity-60"
                            >
                                {loading ? "Sending…" : "Subscribe"}
                                <ArrowRight size={14} weight="bold" />
                            </button>
                        </div>
                        <p className="font-sans text-xs text-white/40 mt-3">One email a month. No spam, ever.</p>
                    </motion.form>
                </div>
            </div>
        </section>
    );
}
